import { inject, Injectable, signal } from '@angular/core';
import { DroplistItem, PageTabsLayoutPageService } from '@eforall/dashboard';
import { Course } from '@interfaces';
import { FuncService } from '../../../services';

/**
 * The list of tabs on this page
 */
export enum ExperienceCoursesPageTabId {
	Experience = 1,
	Tab1 = 2,
	Tab2 = 3,
}

/**
 * The list if main tab droplist views on this page
 */
export enum ExperienceCoursesPageViewId {
	Catalog = 1,
	Monitoring = 2,
	AcceleratorEnrollments = 3,
	AcceleratorCourseFeedback = 4,
}


@Injectable({ providedIn: 'root' })
export class ExperienceCoursesService extends PageTabsLayoutPageService<ExperienceCoursesPageTabId, ExperienceCoursesPageViewId> {

	private readonly func = inject(FuncService);
	public readonly courses = signal<Course[]>([]);

	private static readonly _viewDroplistItems: DroplistItem<never, ExperienceCoursesPageViewId>[] = [
		{
			uniqueId: ExperienceCoursesPageViewId.Catalog, iconContext: {
				iconClass: 'fa-books',
				iconStyle: 'fa-solid',
				text: 'Catalog',
				hideText: 'never',
			},
			customSort: '1-Catalog'
		},
		{
			uniqueId: ExperienceCoursesPageViewId.Monitoring, iconContext: {
				iconClass: 'fa-calendar',
				iconStyle: 'fa-solid',
				text: 'Monitoring',
				hideText: 'never',
			},
			customSort: '2-Monitoring'
		},
		{
			uniqueId: ExperienceCoursesPageViewId.AcceleratorEnrollments, iconContext: {
				iconClass: 'fa-users',
				iconStyle: 'fa-solid',
				text: 'Accelerator Enrollments',
				hideText: 'never',
			},
			customSort: '3-AcceleratorEnrollments'
		},
		{
			uniqueId: ExperienceCoursesPageViewId.AcceleratorCourseFeedback, iconContext: {
				iconClass: 'fa-comments',
				iconStyle: 'fa-solid',
				text: 'Accelerator Course Feedback',
				hideText: 'never',
			},
			customSort: '4-AcceleratorCourseFeedback'
		},
	];
	constructor() {
		super(ExperienceCoursesService._viewDroplistItems, ExperienceCoursesService.name, ExperienceCoursesPageTabId.Experience, ExperienceCoursesPageViewId.Catalog);
	}

	public get viewId() {
		return ExperienceCoursesPageViewId;
	}

	// make this call as part of area service data 
	public async getAllCourses() {
		const courses = await this.func.course.getAllCourses();
		this.courses.set(courses);
	}

	public async reloadData() {
		await this.getAllCourses();
	}

}